// Single source of truth for the Desarrollos tenant UUID.
//
// Every Desarrollos surface filters on this explicitly. That is deliberate and
// NOT redundant with RLS: `customers` carries a second SELECT policy
// ("Public phone lookup own tenant") whose USING clause is only
// `deleted_at IS NULL` — no tenant predicate at all. Postgres OR's policies
// together, so a bare `select` on customers returns every tenant's rows. The
// desarrollos_* tables are properly scoped (they join staff_members on
// tenant_id), but we filter there too so all queries read the same way.
export const DESARROLLOS_TENANT_ID = 'c135ac36-1116-4c5d-9c0a-ddb97579fe35';
